import { TextField } from "@mui/material";

import { t } from "i18next";

import { FunctionComponent, useState } from "react";

import { useNavigate, useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";

import { AutoComplete } from "@/components/AutoComplete/AutoComplete";
import { FlagHeader } from "@/components/Modals/FlagHeader";
import { useGetCompaniesQuery } from "@/pages/Private/redux/companies/companies.api";
import {
	useDuplicateCoursesMutation,
	useGetCourseQuery,
} from "@/pages/Private/redux/courses/courses.api";
import { ROUTE_CONFIG } from "@/routes/config";
import { Modal } from "@/components";

export type DuplicateCourseProps = {
	copyTitle: string;
	setCopyTitle: React.Dispatch<React.SetStateAction<string>>;
	showCopyModal: boolean;
	setShowCopyModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const DuplicateCourse: FunctionComponent<DuplicateCourseProps> = ({
	copyTitle,
	setCopyTitle,
	showCopyModal,
	setShowCopyModal,
}) => {
	const { data: companyData } = useGetCompaniesQuery({
		page: 1,
		limit: 50,
	});

	const navigate = useNavigate();

	const { id = 0 } = useParams();

	const { t } = useTranslation();

	const [duplicateCourse] = useDuplicateCoursesMutation();
	const [selectedCompany, setSelectedCompany] = useState<{ id: number; title: string } | null>(
		null
	);

	function handleCloseCopyModal() {
		setShowCopyModal(false);
	}

	function handleTitleChange(name: string) {
		setCopyTitle(name);
	}

	async function handleCopyModalConfirm(id: number) {
		try {
			const res = await duplicateCourse({
				id,
				name: copyTitle,
				companyId: selectedCompany?.id,
			}).unwrap();

			if (res && !selectedCompany?.id) {
				handleCloseCopyModal();
				navigate(`${ROUTE_CONFIG.COURSES}/edit/${res.id}`);
			} else {
				handleCloseCopyModal();
			}
		} catch (err) {
			console.error("Error", err);
		}
	}

	return (
		<Modal
			aboveHeader={<FlagHeader />}
			cancelButtonText={t("basics.cancel")}
			handleClose={handleCloseCopyModal}
			handleSave={() => handleCopyModalConfirm(+id)}
			isOpened={showCopyModal}
			size="sm"
			submitButtonText={t("basics.confirm")}
			title={t("courses.duplicate.duplicateScenario")}
		>
			<TextField
				className="w-full"
				label={t("courses.duplicate.newTitle")}
				size="medium"
				value={copyTitle}
				onChange={(e) => handleTitleChange(e.target.value)}
			/>
			<AutoComplete
				data={
					companyData?.data
						.filter((comp: { activated?: boolean }) => !comp.activated)
						.map((company) => ({
							title: company.name,
							id: company.id,
						})) ?? []
				}
				handleSearch={() => {
					//Implement
				}}
				handleSelect={(item) =>
					setSelectedCompany(item ? { id: Number(item.id), title: item.title } : null)
				}
				label={t("sidebar.company")}
				position="bottom"
				selectedItem={selectedCompany?.title ?? ""}
			/>
		</Modal>
	);
};

export default DuplicateCourse;
